import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetContactEmailSequenceData as GetContactEmailSequenceDataQuery,
    GetContactEmailSequenceData_contact_dripProgressions as DripProgression,
    GetContactEmailSequenceData_contact_emailAutomationStatuses as EmailAutomationStatus,
    GetContactEmailSequenceData_contact_queuedEmails as QueuedEmail,
    GetContactEmailSequenceDataVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT_EMAIL_SEQUENCE_DATA from '../queries/get-contact-email-sequence-data.graphql';

export function useGetContactEmailSequenceData(
    contactId: string,
    skip: boolean = false
): {
    contactName: string | null | undefined;
    dripProgressions: DripProgression[] | null | undefined;
    emailAutomationStatuses: EmailAutomationStatus[] | null | undefined;
    queuedEmails: QueuedEmail[] | null | undefined;
    isFirstLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, networkStatus, refetch} = useQuery<
        GetContactEmailSequenceDataQuery,
        GetContactEmailSequenceDataVariables
    >(GET_CONTACT_EMAIL_SEQUENCE_DATA, {
        variables: {contactId},
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        contactName: data?.contact?.name,
        dripProgressions: data?.contact?.dripProgressions,
        emailAutomationStatuses: data?.contact?.emailAutomationStatuses,
        queuedEmails: data?.contact?.queuedEmails,
        isFirstLoading: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
